module.exports = __webpack_public_path__ + "images/emoji/oden.a8dfb8a465d04caadfbb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/oden.png
// module id = YLPn
// module chunks = 24